'use strict';

function Purchase(containerId) {
  this.containerId = containerId;
  this.$container = null;

  this.init();
}

Purchase.prototype = $.extend({}, {
  constructor: 'Purchase',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('#' + this.containerId);

    _this.registerCallbacks();

    return _this;
  }
});
